var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ArrayMaxSize, IsArray, IsEnum } from 'class-validator';
import { LegalDocument } from './legal-document.enum.js';
/**
 * The legal documents the Person of the Active office still has to accept
 * before anything else (#1824). Empty when nothing is missing.
 */
export class PendingLegalDocumentsDto {
    documents;
}
/** The documents the Person accepts in the app's acceptance step. */
export class AcceptLegalDocumentsDto {
    documents;
}
__decorate([
    IsArray(),
    ArrayMaxSize(10),
    IsEnum(LegalDocument, { each: true }),
    __metadata("design:type", Array)
], AcceptLegalDocumentsDto.prototype, "documents", void 0);
//# sourceMappingURL=legal-acceptance.dto.js.map